var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3538 9.94497H11.945V14.2587H17.935C17.3775 17 15.0437 18.575 11.945 18.575C8.29125 18.575 5.34625 15.63 5.34625 11.975C5.34625 8.32122 8.29125 5.37622 11.945 5.37622C13.5187 5.37622 14.9412 5.93497 16.0575 6.84872L19.3075 3.59997C17.3275 1.87372 14.7887 0.808716 11.945 0.808716C5.7525 0.808716 0.777496 5.78247 0.777496 11.9762C0.777496 18.17 5.75125 23.1437 11.945 23.1437C17.5287 23.1437 22.6063 19.0825 22.6063 11.9762C22.6063 11.3162 22.505 10.605 22.3538 9.94497Z",
    fill: "#212121"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon_google.cdd2ab83c237934dc2b598f6931e9c41.svg";
export { ForwardRef as ReactComponent };